<template>
  <section class="ege-banner">
    <div class="ege-banner__wrap">
      <div class="ege-banner__container">
        <div :class="['ege-banner__left', {'main': !isSubpage}]">
          <h1 :class="['ege-banner__top-tx', {'sub': isSubpage}]">
            {{ minTitle }}
          </h1>

          <h2
            :class="['ege-banner__title', {'sub': isSubpage}]"
            v-html="bannerTitle"
          />

          <p
            v-if="isSubpage"
            class="ege-banner__descr"
          >
            Мы помогаем детям и родителям чувствовать
            уверенность в своих знаниях и навыках
            для успешной сдачи ЕГЭ и поступления в ВУЗ
          </p>
          <div
            v-else
            class="ege-banner__descr"
          >
            <ul>
              <li>
                <img
                  src="/v2/ege/banner/dot.svg"
                  alt="dot"
                >
                <span>
                  Без <span>стресса</span> для ребенка
                </span>
              </li>
              <li>
                <img
                  src="/v2/ege/banner/dot.svg"
                  alt="dot"
                >
                <span>
                  <span>Авторская</span> методика изучения предмета
                </span>
              </li>
              <li>
                <img
                  src="/v2/ege/banner/dot.svg"
                  alt="dot"
                >
                <span>
                  Сопровождаем до <span>поступления</span>
                </span>
              </li>
            </ul>
          </div>

          <div
            v-if="isSubpage"
            class="ege-banner__row"
          >
            <img
              class="ege-banner__sticker"
              src="/v2/ege/banner/sticker.png"
              alt="free"
            >
            <img
              class="ege-banner__sticker-mob"
              src="/v2/ege/banner/sticker-mob.png"
              alt="free"
            >
            <button
              class="ege-banner__btn"
              @click="$emit('openModal', modalType)"
            >
              Хочу подготовиться
            </button>
          </div>
          <div
            v-else
            class="ege-banner__buttons"
          >
            <img
              src="/v2/ege/banner/sticker-base.svg"
              alt="бесплатно"
              class="ege-banner__sticker"
            >
            <button
              class="ege-banner__btn"
              @click="$emit('openModal', modalType)"
            >
              Получить демо-доступ
            </button>
            <button
              class="ege-banner__btn-outline"
              @click="scrollToCourses"
            >
              Выбрать курс
            </button>
          </div>
        </div>

        <div :class="['ege-banner__rigth', {'sub': isSubpage}]">
          <img
            v-if="!isSubpage"
            src="/v2/ege/banner/banner-image-mobile.webp"
            alt="photo"
            class="ege-banner__mobile-image"
          >

          <div
            v-if="!isSubpage"
            class="parallax"
          >
            <div class="parallax__wrap">
              <div
                ref="elem1"
                class="parallax__elem parallax__elem--1"
                data-rotate="-20"
                data-translate="40"
              >
                <span class="parallax__hatch">#</span>сдайна100
              </div>

              <div
                ref="elem2"
                class="parallax__elem parallax__elem--2"
                data-rotate="-33"
                data-translate="30"
              >
                <span class="parallax__hatch">#</span>будущее
              </div>

              <div
                ref="elem3"
                class="parallax__elem parallax__elem--3"
                data-rotate="3"
                data-translate="10"
              >
                <span class="parallax__hatch">#</span>профессия
              </div>

              <div
                ref="elem4"
                class="parallax__elem parallax__elem--4"
                data-rotate="-20"
                data-translate="-30"
              >
                <span class="parallax__hatch">#</span>вузмечты
              </div>

              <img
                class="parallax__img--1"
                src="/v2/ege/banner/banner-image.webp"
                alt="tutor1"
              >
            </div>
          </div>
          <div
            v-else
            class="parallax sub"
          >
            <div class="parallax__wrap">
              <img
                src="/v2/ege/banner/subpage/bg.webp"
                alt="background"
                class="parallax__bg parallax__bg-sub"
                data-translate="1"
              >
              <img
                :src="subImages.tutor"
                alt="tutor"
                class="parallax__img parallax__tutor-sub"
                data-translate="-1.8"
              >
              <img
                :src="subImages.sticker"
                alt="sticker"
                class="parallax__sticker-sub"
              >
            </div>
          </div>
        </div>
      </div>

      <div class="ege-banner__background background">
        <div class="background__left" />

        <div class="background__rigth" />
      </div>

      <button
        :class="['ege-banner__a-circle a-circle m-btn', {'sub': isSubpage}]"
        @click="scrollTo"
      >
        <img
          class="a-circle__circle"
          src="/v2/ege/banner/circle.svg"
          alt="зачисляем круглый год"
        >

        <img
          class="a-circle__arrow"
          src="/v2/ege/banner/arrow.svg"
          alt="arrow"
        >
      </button>
    </div>
  </section>
</template>

<script>
import { SUBJECTS } from '~/data/constants';
import parallax from '~/utils/mouseMoveParallax';
import scrollTo from '~/utils/scrollTo';

export default {
  name: 'EgeBanner',

  props: {
    minTitle: {
      type: String,
      required: true,
    },
    bannerTitle: {
      type: String,
      required: true,
    },
    modalType: {
      type: String,
      default: 'base',
    },
  },
  computed: {
    isSubpage() {
      return this.$route.name === 'ege-subpage';
    },
    subImages() {
      if (this.isSubpage) {
        const pageName = this.$route?.params?.subpage;
        const path = '/v2/ege/banner/subpage/ege';

        switch (pageName) {
          case SUBJECTS.matematika:
            return { tutor: `${path}-tutor-math.webp`, sticker: `${path}-tutor-math-sticker.webp` };
          case SUBJECTS.matematikaProfil:
            return { tutor: `${path}-tutor-math.webp`, sticker: `${path}-tutor-math-sticker.webp` };
          case SUBJECTS.russkijYazyk:
            return { tutor: `${path}-tutor-russian.webp`, sticker: `${path}-tutor-russian-sticker.webp` };
          case SUBJECTS.anglijskijYazyk:
            return { tutor: `${path}-tutor-english.webp`, sticker: `${path}-tutor-english-sticker.webp` };
          case SUBJECTS.informatika:
            return { tutor: `${path}-tutor-informatics.webp`, sticker: `${path}-tutor-informatics-sticker.webp` };
          case SUBJECTS.obshchestvoznanie:
            return { tutor: `${path}-tutor-social.webp`, sticker: `${path}-tutor-social-sticker.webp` };
          case SUBJECTS.istoriya:
            return { tutor: `${path}-tutor-history.webp`, sticker: `${path}-tutor-history-sticker.webp` };
          case SUBJECTS.fizika:
            return { tutor: `${path}-tutor-physics.webp`, sticker: `${path}-tutor-physics-sticker.webp` };
          case SUBJECTS.himiya:
            return { tutor: `${path}-tutor-chemistry.webp`, sticker: `${path}-tutor-chemistry-sticker.webp` };
          case SUBJECTS.biologiya:
            return { tutor: `${path}-tutor-biology.webp`, sticker: `${path}-tutor-biology-sticker.webp` };
          case SUBJECTS.literatura:
            return { tutor: `${path}-tutor-literature.webp`, sticker: `${path}-tutor-literature-sticker.webp` };
          default:
            return { tutor: null, sticker: null };
        }
      }
      return null;
    },
  },

  mounted() {
    if (window.innerWidth > 1024) {
      document.querySelector('.ege-banner').addEventListener('mousemove', this.parallax);
    }
  },
  beforeDestroy() {
    document.querySelector('.ege-banner').removeEventListener('mousemove', this.parallax);
  },
  methods: {
    parallax(e) {
      parallax(e, '.ege-banner');
    },
    scrollTo() {
      const headerHeight = document.getElementById('headerComponent').clientHeight;
      return scrollTo.call(this, '#packages', this.$route.path, headerHeight);
    },
    scrollToCourses() {
      const elem = document.querySelector('.high-scores');
      if (elem) {
        elem.scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ege-banner {
  padding-bottom: 62px;
  margin-bottom: -62px;
  min-height: 681px;

  overflow: hidden;

  &__wrap {
    position: relative;
    width: calc(100% - 120px);
    margin: 80px 60px 0;
    padding: 0 8px;
    border-radius: 60px;

    background: $white-color;

    @media (max-width: 1480px) {
      width: 100%;
      max-width: 1360px;
      margin: 80px auto 0;
    }

    @include media-down(tablet) {
      width: calc(100% - 16px);
      padding: 0;
      margin-top: 64px;
      border-radius: 24px;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;

      display: block;

      background: url('/v2/main/banner/background.svg');
      border-radius: 60px;

      pointer-events: none;

      @include media-down(tablet) {
        background-size: 1850px;
      }
    }
  }

  &__container {
    z-index: 1;

    display: flex;
    justify-content: space-between;

    margin: 0 auto;
    padding: 120px 8px 0;

    max-width: 1260px;
    width: 100%;
    overflow: visible;

    @include media-down(laptop) {
      flex-direction: column;
      gap: 32px;

      padding: 96px 8px 0;

      overflow: hidden;
    }

    @include media-between($tablet, $laptop) {
      padding: 126px 8px 0;
    }

    @include media-down(tablet) {
      gap: 0;
      overflow: hidden;
      border-bottom-right-radius: 24px;
      border-bottom-left-radius: 24px;
      padding: 24px 8px 0;
    }
  }

  &__left {
    flex-shrink: 0;

    width: 630px;
    position: relative;
    padding-bottom: 172px;
    z-index: 2;

    @media (max-width: 1500px) {
      padding-bottom: 72px;
    }

    @include media-down(desktop) {
      width: 600px;
    }

    @include media-down(laptop) {
      margin: 0 auto;

      max-width: 550px;
      width: auto;
    }

    @include media-down(tablet) {
      padding-bottom: 0;
    }
  }

  &__rigth {
    position: relative;
    z-index: 1;

    @include media-down(tablet) {
      height: 298px;
    }
  }
  &__rigth.sub {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;

    @include media-down(laptop) {
      position: relative;
      left: auto;
      top: auto;
      overflow: visible;
    }

    @include media-down(tablet) {
      height: 292px;
    }
  }

  &__top-tx {
    margin-bottom: 15px;

    font-size: 18px;
    font-weight: 700;
    color: $blue-dark;

    @include media-down(laptop) {
      text-align: center;
    }

    @include media-down(tablet) {
      margin-bottom: 8px;

      font-size: 16px;
    }
  }
  &__top-tx.sub {
    color: rgba($black-color, .4);
  }

  &__title {
    position: relative;

    margin-bottom: 15px;

    width: fit-content;

    font-size: 65px;
    font-weight: 700;
    line-height: 65px;
    letter-spacing: -0.02em;
    color: $black;

    text-transform: uppercase;

    @include media-down(desktop) {
      font-size: 46px;
    }

    @include media-down(laptop) {
      width: auto;
      text-align: center;
    }

    @include media-down(tablet) {
      margin-bottom: 12px;

      font-size: 30px;
      font-weight: 700;
      line-height: 33px;
      letter-spacing: -0.03em;
    }

    ::v-deep & > span {
      display: inline-block;
      position: relative;

      &:before {
        content: '';
        width: 106%;
        height: 98%;
        background-color: $blue-dark;
        box-shadow: 0 2px 35px 0 rgba($blue-darkest, .2);
        position: absolute;
        left: -3%;
        bottom: -2%;
      }

      span {
        position: relative;
        z-index: 2;
        color: $white-color;
      }
    }
  }
  &__title.sub {
    font-size: 45px;
    line-height: 49.5px;

    @include media-down(tablet) {
      font-size: 30px;
      line-height: 33px;
    }
  }

  &__descr {
    margin-bottom: 42px;
    max-width: 500px;

    font-size: 24px;
    font-weight: 500;
    line-height: 31px;
    color: $black;

    @include media-down(laptop) {
      text-align: center;
      margin: 0 auto 42px;
    }

    @include media-down(tablet) {
      margin-bottom: 24px;

      font-size: 20px;
      font-weight: 600;
      line-height: 20px;
    }

    br {
      @include media-down(tablet) {
        display: none;
      }
    }

    ul {
      display: flex;
      flex-direction: column;
      gap: 8px;

      @include media-down(tablet) {
        max-width: 290px;
        margin: 0 auto;
      }

      li {
        display: flex;
        align-items: center;
        gap: 8px;
        text-align: left;

        span {
          font-size: 24px;
          font-weight: 500;
          line-height: 31px;
          color: $black;
          text-align: left;

          span {
            color: #FF4F01;
          }

          @include media-down(tablet) {
            font-size: 18px;
            font-weight: 500;
            line-height: 18px;
          }
        }
      }
    }
  }

  &__row {
    position: relative;

    @include media-down(laptop) {
      display: flex;
      justify-content: center;
    }
  }

  &__buttons {
    display: flex;
    gap: 10px;
    position: relative;

    @include media-down(tablet) {
      flex-direction: column;
      align-items: center;
      gap: 16px;
      margin-top: 44px;
    }

    .ege-banner__sticker {
      left: -10px;
      top: -45px;

      @include media-down(tablet) {
        display: block;
        width: 100px;
        left: 10px;
        top: -35px;
      }
    }

    .ege-banner__btn {
      width: 356px;
      font-family: 'TildaSans', sans-serif;

      @include media-down(tablet) {
        width: 292px;
        white-space: nowrap !important;
      }
    }

    .ege-banner__btn-outline {
      width: 231px;
      height: 74px;
      display: flex;
      align-items: center;
      justify-content: center;

      border: 2px solid #2961AA;
      border-radius: 100px;
      background-color: $white-color;

      font-family: 'TildaSans', sans-serif;
      font-size: 30px;
      font-weight: 500;
      line-height: 30px;
      color: $black-color;

      cursor: pointer;
      transition: background-color .2s ease-out;

      &:hover {
        background-color: lighten(#2961AA, 50%);
      }

      @include media-down(tablet) {
        width: 292px;
        height: 64px;

        font-size: 24px;
      }
    }
  }

  &__sticker {
    position: absolute;
    top: -52px;
    left: 229px;
    width: 125px;

    @include media-down(laptop) {
      left: calc(50% + 48px);
    }

    @include media-down(tablet) {
      display: none;
    }
  }
  &__sticker-mob {
    display: none;

    @include media-down(tablet) {
      display: block;
      width: 125px;
      position: absolute;
      top: 38px;
      left: calc(50% - 171px);
    }
  }

  &__btn {
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 319px;
    height: 74px;

    border-radius: 100px;
    border: 2px solid $brown-dark;
    background-color: $ege-orange;
    box-shadow: 0 4px 0 0 $brown-dark;

    font-size: 30px;
    font-weight: 700;
    line-height: 100%;
    color: $white-color;
    font-family: 'TildaSans', sans-serif;

    cursor: pointer;
    transition: transform .2s ease-out, box-shadow .2s ease-out;

    &:hover {
      box-shadow: 0 0 0 0 $brown-dark;
      transform: translate(0, 4px);
    }

    @include media-down(tablet) {
      width: 264px;
      height: 64px;

      font-size: 24px;
    }
  }

  &__note {
    font-weight: 700;
    font-size: 16px;
    line-height: 16px;
    text-align: center;
    color: #afaea8;

    @include media-down(laptop) {
      display: none;
    }
  }

  &__a-circle {
    position: absolute;
    z-index: 1;
    bottom: -60px;

    left: calc(50% - 60px);

    @include media-down(laptop) {
      left: calc(50% - 47px);
      bottom: -47px;
    }
  }

  &__mobile-image {
    display: none;

    @include media-down(tablet) {
      display: block;
      width: 344px;
      max-width: 100%;
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translate(-50%);
    }
  }
}

.parallax {
  position: relative;

  width: 505px;
  height: 100%;

  @media (max-width: 1750px) {
    width: 455px;
    margin-right: 100px;
  }

  @media (max-width: 1500px) {
    width: 380px;
    margin-right: 150px;
  }

  @include media-down(laptop) {
    top: 0;
    left: 0;

    margin: 0 auto;

    width: 475px;
    height: 490px;
  }

  @include media-down(tablet) {
    display: none;
  }

  &__elem {
    position: absolute;
    z-index: 4;

    display: flex;
    justify-content: center;
    align-items: center;

    padding: 0 10px;

    width: fit-content;
    height: 53px;

    border-radius: 200px;
    background-color: $white-color;
    box-shadow: 0 2px 35px 0 rgba($blue-darkest, .2);

    font-size: 24px;
    font-weight: 800;
    color: $black-color;
    text-transform: uppercase;
    white-space: nowrap;

    will-change: transform;

    transition: 0.2s ease-out;

    &--1 {
      top: 59%;
      left: -15%;

      transform: rotate(16.9deg);

      @include media-between($laptop, $desktop) {
        right: 0;
      }
    }

    &--2 {
      bottom: 6%;
      left: 17%;

      transform: rotate(-5.82deg);
    }

    &--3 {
      left: 53%;
      bottom: 16%;

      transform: rotate(9.79deg);

      @include media-between($laptop, $desktop) {
        right: 230px;
        bottom: 43px;
      }
    }

    &--4 {
      bottom: 8%;
      right: -27%;

      transform: rotate(-6.29deg);

      @include media-between($laptop, $desktop) {
        bottom: 240px;
        left: 10px;
      }
    }
  }

  &__bg {
    position: absolute;
    bottom: 0;
    left: -27%;

    width: 164%;

    will-change: transform;

    transition: 0.2s ease-out;
  }

  &__bg-sub {
    position: absolute;

    display: block;

    width: 78%;
    height: auto;
    bottom: -2%;
    right: -16%;
    left: auto;

    background-color: transparent;
    box-shadow: none;
    border-radius: 0;

    object-fit: contain;
    transition: .2s ease-out;
    will-change: transform;

    z-index: 1;

    @include media-down(laptop) {
      width: 168%;
      right: auto;
      left: 50%;
      transform: translateX(-50%);
    }

    @include media-down(tablet) {
      width: 568px;
      left: 50%;
      transform: translateX(-55%);
      bottom: -20px;
    }
  }

  &__tutor-sub {
    position: absolute;
    bottom: 0;
    width: 42.5%;
    height: auto;
    right: 0.5%;

    background-color: transparent;
    box-shadow: none;
    border-radius: 0;

    object-fit: contain;
    transition: .2s ease-out;
    will-change: transform;

    z-index: 2;

    @include media-down(laptop) {
      width: 100%;
      right: auto;
      left: 50%;
      transform: translateX(-50%);
    }

    @include media-down(tablet) {
      width: 340px;
      bottom: -40px;
    }
  }

  &__sticker-sub {
    position: absolute;
    width: 332px;
    bottom: -10px;
    right: 10%;
    left: auto;
    height: auto;
    display: block;
    border-radius: 0;
    background-color: transparent;
    box-shadow: none;

    z-index: 3;

    @include media-down(laptop) {
      transform: translateX(-50%);
      left: 50%;
    }

    @include media-down(tablet) {
      width: 232px;
      bottom: -5px;
    }
  }

  &__img {
    &--1 {
      position: absolute;
      bottom: -12px;
      right: 0;
      width: 160%;
      left: -12%;
      z-index: 2;

      @include media-down(laptop) {
        width: 140%;
        left: 50%;
        transform: translateX(-45%) !important;
      }
    }
    &--2 {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 94%;
      left: 17%;
      z-index: 3;
    }
    &--3 {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 81%;
      left: 54%;
      z-index: 2;
    }
  }
}
.parallax.sub {
  height: 100%;
  margin: 0 auto;
  max-width: 1260px;
  position: relative;
  width: 100%;

  @include media-down(laptop) {
    position: relative;
    margin: 0 auto;
    width: 475px;
    height: 490px;
  }

  @include media-down(tablet) {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.background {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;

  width: 100%;
  height: 100%;
  border-radius: 60px;

  overflow: hidden;

  pointer-events: none;

  @include media-down(tablet) {
    border-radius: 24px;
  }

  &__left {
    position: absolute;
    bottom: -19.87%;
    left: -6.98%;

    width: 18.23%;
    height: 46.05%;

    border-radius: 816px;

    background-color: $blue-bright;

    filter: blur(150px);
    opacity: 0.5;

    @include media-down(tablet) {
      width: 48.61%;
      height: 21.875%;
      bottom: auto;
      top: -4.75%;
      left: -12.92%;
      opacity: 0.7;
      filter: blur(100px);

      animation: none;
    }
  }

  &__rigth {
    position: absolute;
    top: -11.32%;
    right: -4.27%;

    width: 18.23%;
    height: 46.05%;

    border-radius: 816px;

    background-color: $brown-light;

    opacity: 0.5;
    filter: blur(150px);

    @include media-down(tablet) {
      width: 48.61%;
      height: 21.875%;
      top: auto;
      bottom: -6%;
      right: -11.66%;
      opacity: 0.6;
      filter: blur(100px);

      animation: none;
    }
  }
}

.a-circle {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 120px;
  height: 120px;

  border-radius: 50%;

  overflow: hidden;

  @include media-down(laptop) {
    width: 94px;
    height: 94px;
  }

  &__circle {
    position: absolute;
    top: 0;
    right: 0;

    width: 100%;
    height: 100%;

    pointer-events: none;

    animation: spine 20s linear infinite;
  }

  &__arrow {
    position: relative;
  }
}
.a-circle.sub {
  @include media-down(laptop) {
    display: none;
  }
}
</style>
